var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","onselectstart":"return false;"}},[_c('transition',{attrs:{"name":"change","mode":"out-in","enter-active-class":"animate__animated animate__zoomIn"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }